import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { MenuButton, ListItem } from "react-md";
import { truncate } from "lodash";
import { caseAlertMarkRead } from "actions/CaseAlerts";
import { setQASwitchCaseDialog } from "actions/qualityAssurance";

class CaseAlerts extends React.Component {
  constructor(props) {
    super(props);
    this.getIcon = this.getIcon.bind(this);
    this.getIconClassName = this.getIconClassName.bind(this);
    this.mapCaseAlertsToMenuItems = this.mapCaseAlertsToMenuItems.bind(this);
    this.mapActionToIcon = this.mapActionToIcon.bind(this);
    this.newCaseAlerts = this.newCaseAlerts.bind(this);
    this.rootRef = React.createRef();
    this.state = {
      menuOpen: false,
      newCaseAlerts: this.newCaseAlerts()
    };
  }

  componentDidUpdate() {
    const newCaseAlerts = this.newCaseAlerts();
    if (this.state.newCaseAlerts !== newCaseAlerts)
      this.setState({
        newCaseAlerts: newCaseAlerts
      });
  }

  getIcon() {
    const { newCaseAlerts } = this.state;
    if (newCaseAlerts) return "notifications";
    return "notifications_none";
  }

  getIconClassName() {
    const { menuOpen } = this.state;
    return `md-icon material-icons${menuOpen ? " active" : " inactive"}`;
  }

  mapCaseAlertsToMenuItems() {
    const { caseAlerts, caseAlertMarkRead, setQASwitchCaseDialog } = this.props;
    if (!caseAlerts || !caseAlerts.length)
      return (
        <ListItem
          primaryText={"No Case Alerts"}
        />
      );
    let alerts = caseAlerts.map(({ isNew, id, action, controlNumber, customerNumber, customerName, message, timeStamp, qaQueueTypeId }) => {
      return (
        <ListItem
          key={id}
          id={id}
          leftIcon={<i title={action} className={"md-icon material-icons"}>{this.mapActionToIcon(action)}</i>}
          primaryText={`${controlNumber} : ${customerName} (${customerNumber})`}
          secondaryText={`${truncate(message, { length: 70 })}\n${action} ${timeStamp}`}
          className={isNew ? "unread" : ""}
          onClick={() => {
            caseAlertMarkRead(id);
            if (qaQueueTypeId === 1) {
              navigator.clipboard.writeText(controlNumber);
            } else {
              setQASwitchCaseDialog(true, controlNumber);
              this.setState({ menuOpen: false });
            }
          }}
          threeLines
        />
      );
    });
    alerts.push(
      <ListItem
        key="mark-all-read"
        primaryText="Mark All as Read"
        className={"md-btn md-btn--raised mark-read"}
        onClick={() => caseAlerts.forEach(s => caseAlertMarkRead(s.id))}
      />);
    return alerts;
  }

  mapActionToIcon(action) {
    switch (action) {
      case "Returned by Manager":
      case "Returned from Field":
      default:
        return "message";
    }
  }

  newCaseAlerts() {
    const { caseAlerts } = this.props;
    if (caseAlerts)
      return caseAlerts.find(caseAlert => caseAlert.isNew) || false;
    return false;
  }

  render() {
    const { menuOpen } = this.state;
    return (
      <MenuButton
        id={"case-alerts"}
        icon
        visible={menuOpen}
        onVisibilityChange={() => { }}
        onClick={() => this.setState({ menuOpen: !menuOpen })}
        className={this.getIconClassName()}
        position={MenuButton.Positions.TOP_RIGHT}
        menuItems={this.mapCaseAlertsToMenuItems()}
        anchor={{
          x: MenuButton.HorizontalAnchors.INNER_RIGHT,
          y: MenuButton.VerticalAnchors.BOTTOM,
        }}
        simplifiedMenu={false}
        ref={this.rootRef}
      >
        {this.getIcon()}
      </MenuButton>
    );
  }
}

CaseAlerts.defaultProps = {
  place: "bottom",
  caseAlerts: null
};

CaseAlerts.propTypes = {
  //pure props
  place: PropTypes.string,

  //global state
  caseAlerts: PropTypes.array,
  rights: PropTypes.array,

  //actions
  caseAlertMarkRead: PropTypes.func,
  setQASwitchCaseDialog: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  return {
    caseAlerts: state.caseAlerts,
    rights: state.user.profile.rights,
  };
};

const mapDispatchToProps = dispatch => ({
  caseAlertMarkRead(id) {
    dispatch(caseAlertMarkRead(id));
  },
  setQASwitchCaseDialog(shouldShowCompletedCaseDialog, controlNumber) {
    dispatch(setQASwitchCaseDialog(shouldShowCompletedCaseDialog, controlNumber));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CaseAlerts);
